import React, { useState, useEffect } from 'react';
import { __ } from '@wordpress/i18n';
import DefaultStep from '../../components/default-step'
import SitePreview from "../../components/site-preview";
import { CustomizeSteps } from './customize-steps'

const CustomizeSite = () => {
	const [currentStep, setCurrentState] = useState(0);
	const currentStepObject = CustomizeSteps[currentStep];
	let CurrentStepContent;
	let CurrentStepActions;
	let CurrentStepControls;

	if (typeof currentStepObject !== 'undefined') {
		CurrentStepContent = currentStepObject.content;
		CurrentStepActions = currentStepObject.actions;
		CurrentStepControls = currentStepObject.controls;
	}

	useEffect(() => {
		let previousIndex = parseInt(currentStep) - 1;
		let nextIndex = parseInt(currentStep) + 1;

		if (nextIndex > 0 && nextIndex < CustomizeSteps.length) {
			document.body.classList.remove(CustomizeSteps[nextIndex].class)
		}

		if (previousIndex >= 0) {
			document.body.classList.remove(CustomizeSteps[previousIndex].class)
		}

		document.body.classList.add(CustomizeSteps[currentStep].class)
	});

	const setNextStep = () => {
		setCurrentState(currentStep + 1);
	}

	const setPreviousStep = () => {
		setCurrentState(currentStep - 1);
	}

	return (
		<DefaultStep
			content={
				<CurrentStepContent customizeStep={true}
					onNextClick={setNextStep}
					onPreviousClick={setPreviousStep} />
			}
			controls={CurrentStepControls && <CurrentStepControls customizeStep={true}
				onNextClick={setNextStep}
				onPreviousClick={setPreviousStep} />
			}
			actions={
				<>
					{
						currentStep < CustomizeSteps.length &&
						<>
							<CurrentStepActions ml1 customizeStep={true}
								onNextClick={setNextStep}
								onPreviousClick={setPreviousStep}
							/>
						</>
					}
				</>
			}

			preview={<SitePreview />}
		/>
	)
}

export default CustomizeSite
